import { Deduction, PayeeRow } from "@wingspanhq/wingspan-api-sdk";
import isEmpty from "lodash/isEmpty";
import { cleanCSVData } from "../../../shared/utils/csv";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";

export type DeductionTableItem = {
  deduction: Deduction;
  payeeRow?: PayeeRow;
};
const mapDeductionTableItemData = (tableItem: DeductionTableItem) => {
  const { deduction, payeeRow } = tableItem;

  if (!deduction) {
    return {};
  }

  const payeeRowCompanyName =
    payeeRow?.profile?.companyName || payeeRow?.profile?.doingBusinessAs;

  return {
    "Created Date": deduction.events?.createdAt,
    // "Start Date" is dropped: v1 `IDeduction.startDate` has no v3 counterpart.
    // See V3_MIGRATION_TRACKER.md · /v3/payments/deductions.
    "External Contractor ID": payeeRow?.externalId,
    "Contractor Name": payeeRow ? selectorSearchRowName(payeeRow) : undefined,
    "Contractor First Name": payeeRow?.profile?.firstName,
    "Contractor Last Name": payeeRow?.profile?.lastName,
    // The preferred name is not materialized on the v3 search row.
    "Contractor Preferred Name": undefined,
    "Contractor Company Name": payeeRowCompanyName,
    "Contractor Email": payeeRow?.email,
    "Deduction Status": deduction.status,
    // v1 `type` (PrePayment / PostPayment) is `applicationType` on v3;
    // `deductionType` is a separate category axis v1 had no field for.
    "Deduction Type": deduction.applicationType,
    "Deduction Category": deduction.deductionType,
    "Deducted Payable IDs": (deduction.application ?? [])
      .map(a => a.payableId)
      .join(", "),
    "Deduction ID": deduction.id,
    "Deduction Details": deduction.detail,
    // v1 `deductionTemplateId` becomes the recurring-deduction reference.
    "Recurring Deduction ID": deduction.recurringDeductionId,
    Amount: deduction.amount,
    "Amount Deducted": (deduction.application ?? [])
      .map(a => a.amountDeducted ?? 0)
      .reduce((a, b) => a + b, 0),
    Currency: deduction.currency,
    Priority: deduction.priority,
    "Deduction Name": deduction.name
  };
};
export const mapDeductionsTableToCSV = (data: Array<DeductionTableItem>) => {
  let cleanResult = [];

  const dirtyResult = data
    .map(d => {
      try {
        return mapDeductionTableItemData(d);
      } catch (error) {
        console.error(error);
      }
      return {};
    })
    .filter(d => !isEmpty(d));

  cleanResult = dirtyResult.map(d =>
    cleanCSVData(d, dirtyResult)
  ) as Array<any>;

  return cleanResult;
};
